import { render, staticRenderFns } from "./ProductRepeaterItem.vue?vue&type=template&id=774635c7&scoped=true&"
import script from "./ProductRepeaterItem.vue?vue&type=script&lang=js&"
export * from "./ProductRepeaterItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductRepeaterItem.vue?vue&type=style&index=0&id=774635c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774635c7",
  null
  
)

export default component.exports